export const event = {
  brand: 'Meet the Eatmons',
  hosts: 'Curtis & Spring Eatmon IV',
  title: 'Unified Success',
  subtitle: 'MasterClass',
  dateLabel: 'Friday, October 16',
  timeLabel: '7:15 PM CST',
  isoDate: '2026-10-17T00:15:00Z',
  tagline: 'Built to carry more',
  location: 'Live on Zoom',
  payUrl: 'https://link.builderspro.io/payment-link/6aaca2e0f426560dbc2f0edf',
  bundlePayUrl:
    'https://link.builderspro.io/payment-link/6aaca19f9f7ff2c808a76436',
  registerUrl: 'https://us02web.zoom.us/meeting/register/qyzb9PAcTPygXFbxXGLtqg',
  backdropUrl:
    'https://cdn.magicpatterns.com/patterns/generated-images/e9a16438-5cc8-4fd3-be6c-58272df09209.jpg',
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/nZFMLPkSn6UgL8WRsGMvhA/Meet_the_3.png',
  portraitUrl:
    'https://cdn.magicpatterns.com/uploads/jWaGMCJwuLaBr6CY7N7VKd/IMG_7273_2.jpg',
}

export const promise =
  "We help ambitious couples who know they're called to build something significant, but refuse to sacrifice their relationship to build it."

export const bio = [
  "We help ambitious couples who know they're called to build something significant, but refuse to sacrifice their relationship to build it!",
  'We’re Curtis and Spring Eatmon, and we learned the hard way that success will test more than your capacity… It will test your connection! We recognized that the higher you go, the more intentional you have to become about who you’re becoming together!',
  'This live MasterClass gives you the conversations, strategies, and tools to get aligned on what matters most, and move forward with one vision, one direction, and one powerful partnership so your relationship can be the foundation for everything you’re called to become!',
]

export const bioTagline = 'Build the relationship. Align the vision. Multiply the impact.'

export const pricing = [
  {
    name: 'Single class',
    price: '$97',
    unit: 'per class',
    description:
      'Join the live MasterClass, get the workbook, and keep the replay.',
    perks: ['One live class', 'Workbook + replay', 'Open Q&A'],
    url: 'https://link.builderspro.io/payment-link/6aaca2e0f426560dbc2f0edf',
    featured: false,
  },
  {
    name: 'Complete experience',
    price: '$250',
    unit: 'all 3 classes',
    description:
      'All three classes in the series — the full arc, at the best value.',
    perks: [
      'All 3 live classes',
      'Workbook + replays for each',
      'Open Q&A every session',
      'Save $41 vs. single classes',
    ],
    url: 'https://link.builderspro.io/payment-link/6aaca19f9f7ff2c808a76436',
    featured: true,
  },
]

export const curriculum = [
  {
    title: 'Alignment before ambition',
    body: 'How to set goals as one household instead of two competing agendas — and what to do when your timelines disagree.',
  },
  {
    title: 'Money, roles & the hard talks',
    body: 'The conversations most couples avoid until it costs them. Scripts and structure for handling them without the blowup.',
  },
  {
    title: 'Protecting the relationship under pressure',
    body: 'Building rhythms that survive busy seasons, so growth never gets paid for with your peace.',
  },
  {
    title: 'Live Q&A with Curtis & Spring',
    body: 'Bring your real situation. We answer openly, on camera, for as long as the questions keep coming.',
  },
]

export const takeaways = [
  '90 minutes live with Curtis & Spring',
  'Replay access for every attendee',
  'The Unified Success workbook',
  'Open Q&A — no scripted panel',
]
